import { render, staticRenderFns } from "./DealerSignupLookup.vue?vue&type=template&id=5a83a3b5&scoped=true&"
import script from "./DealerSignupLookup.vue?vue&type=script&lang=js&"
export * from "./DealerSignupLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a83a3b5",
  null
  
)

export default component.exports